var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"initial-cell text-xs cell sticky left-0 px-2 py-1.5 flex items-center justify-start border-r-2 border-gray-200 dark:border-gray-600 whitespace-nowrap min-w-[16rem]",class:[_vm.background]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }